import api from './api.js';

export async function getAccess() {
  const response = await api.get('/documentation/access');
  return response.data;
}

export async function getPrd() {
  const response = await api.get('/documentation/prd');
  return response.data;
}

export async function getDocumentationSettings() {
  const response = await api.get('/documentation/settings');
  return response.data;
}

export async function updateDocumentationSettings(allowedRoles, reason = null) {
  const response = await api.put('/documentation/settings', { allowedRoles, reason });
  return response.data;
}
